"use client";

import { useTranslations } from "next-intl";
import React, { useState } from "react";
import Search from "../icons/Search";
import DestinationCard from "./DestinationCard";
import {
  GetTravelGuidesByStatusAction,
  searchTravelGuideByCountryAction,
} from "actions/travel-guide";
import { ContentStatus } from "@prisma/client";
import useSWR from "swr";
import { Skeleton } from "@nextui-org/react";
import useDebounce from "hooks/use-debound";

interface IProps {
  locale: string;
}

function PopularDestinations(props: IProps) {
  const t = useTranslations("News");
  const [searchInput, setSearchInput] = useState<string>();
  const debouncedSearch = useDebounce(searchInput, 1000);
  const data = useSWR("GetTravelGuidesByStatusAction", () =>
    GetTravelGuidesByStatusAction(ContentStatus.PUBLIC, props.locale, 6, 1)
  );

  const searchData = useSWR(
    "searchCountry?key=" + debouncedSearch,
    () => {
      if (debouncedSearch) {
        return searchTravelGuideByCountryAction(props.locale, debouncedSearch);
      } else return null;
    },
    {
      keepPreviousData: true,
    }
  );

  return (
    <section
      id="popular-destinations"
      className=" bg-white space-y-[80px] w-full flex items-center
                   flex-col justify-center max-w-screen-xl pb-[80px] px-[24px] xl:px-[0px]"
    >
      <div
        className=" flex w-full max-w-screen lg:max-w-screen-xl lg:mt-[100px] mt-[60px]
                     flex-col lg:flex-row items-center justify-between"
      >
        <h2 className="h2">{t("popular_destinations")}</h2>
        <div
          className="bg-[#D9D9D9] overflow-hidden rounded-[8px] flex mt-[10px] xl:mt-[0px]
         flex-row items-stretch h-[52px] w-full lg:w-fit"
        >
          <input
            type="text"
            placeholder={t("search")}
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            className=" outline-none  bg-transparent w-full lg:w-[384px]
                        px-[32px] placeholder:text-[#6F6F6F]"
          />
          <button
            className=" h-full bg-black flex-grow w-[64px] flex
                             items-center justify-center"
          >
            <Search />
          </button>
        </div>
      </div>
      <div className=" w-full grid grid-cols-1 lg:grid-cols-3 lg:gap-[32px] gap-[12px]">
        {searchData.isLoading || data.isLoading ? (
          <>
            <Skeleton className=" w-full aspect-[1/0.68] rounded-[28px] bg-[#D9D9D9]" />
            <Skeleton className=" w-full aspect-[1/0.68] rounded-[28px] bg-[#D9D9D9]" />
            <Skeleton className=" w-full aspect-[1/0.68] rounded-[28px] bg-[#D9D9D9]" />
          </>
        ) : searchInput ? (
          searchData.data?.length == 0 ? (
            <>
              <p>No result found</p>
            </>
          ) : (
            <>
              {searchData.data?.map((item) => {
                return (
                  <DestinationCard
                    {...item.travelGuide}
                    key={item.travelGuide.id}
                  />
                );
              })}
            </>
          )
        ) : (
          <>
            {data.data?.results.map((item) => {
              return <DestinationCard {...item} key={item.id} />;
            })}
          </>
        )}
      </div>
    </section>
  );
}

export default PopularDestinations;
